import { useLocation } from "react-router";

// Create better TS suited version of this hook (https://gist.github.com/karol-majewski/dd45139e103db2811fcdaa74a9de9a18)
export const useQuery = (): URLSearchParams =>
  new URLSearchParams(useLocation().search);
